import React from 'react'
import { Menu } from "semantic-ui-react";
import { Card } from 'semantic-ui-react'


export default class DocumentsListItem extends React.Component {

  render () {
    const document = this.props.document
    let hrefString = Routes.download_api_document_path({ id: document.id, _options: true })
    return (
      <Card key={document.id} href={hrefString} target="_blank" rel="noopener noreferrer">
      <Card.Content>
        <Card.Header >
          {document.name}
        </Card.Header>
      </Card.Content>
        <Card.Content extra style={{padding: 0}}>
          <Menu compact icon borderless secondary size='large'>
            <Menu.Item icon='download' href={Routes.download_api_document_path({id: document.id, download: true, _options: true})} as='a'/>
          </Menu>
        </Card.Content>
    </Card>)
  }
}


